import type { ApiCallResult } from '../util/apiClient';
import { assumeArray, assumeBoolean, assumeObject, assumeString } from '../type-guards/assumeType';
import { getEmbed } from './hal';

export function unknownBody(result: ApiCallResult): unknown {
  return result.data;
}

export function assumeResultObject<T = Record<string, never>>(result: ApiCallResult, checkKey?: keyof T): T {
  return assumeObject<T>(result.data, checkKey);
}

export function assumeResultArray<T = unknown>(result: ApiCallResult): T[] {
  return assumeArray<T>(result.data);
}

export function assumeResultString(result: ApiCallResult): string {
  return assumeString(result.data);
}

export function assumeResultBoolean(result: ApiCallResult): boolean {
  return assumeBoolean(result.data);
}

export function assumeEmbedCollection<T>(result: ApiCallResult): T[] {
  return getEmbed<T>(result.data, 'collection', []);
}

export function vagueResult(result: ApiCallResult): any {
  return result.data;
}

export function assumeResultObjectOrNull<T = Record<string, never>>(result: ApiCallResult, checkKey?: keyof T): T | null {
  const data = result.data;
  if (data == null) {
    return null;
  }
  return assumeObject<T>(result.data, checkKey);
}

export function assumeResultObjectOrNoContent<T = Record<string, never>>(result: ApiCallResult, checkKey?: keyof T): T | null {
  if (result.status === 204 || result.data === '') {
    return null;
  }
  return assumeObject<T>(result.data, checkKey);
}
